export default __webpack_public_path__ + "static/media/GeneralInfo.c9e51200.svg";